import { Button, Flex, Typography } from 'antd'
import dayjs, { Dayjs } from 'dayjs'
import React from 'react'
import { useTranslation } from 'react-i18next'
import CustomRangePicker from 'src/app/shared/components/common/range-picker'
import { useDisableFutureDates } from 'src/app/shared/hooks/useDisableFutureDates'

import {  RefreshIcon, WhiteSearchIcon } from 'src/assets/icons'

interface Props {
  dateRange: any
  setDateRange: React.Dispatch<any>
  handleSearch: () => void
  handleReset: () => void
}

function SearchBar(props: Props) {
  const { t } = useTranslation()
  const { dateRange, setDateRange, handleSearch, handleReset } = props
  const dateFormat = 'YYYY-MM-DD'
  const { disableFutureDates } = useDisableFutureDates()

  return (
    <Flex vertical gap={2}>
      <Typography className='dateText'>
        {t('IssuedCheckProcessingLog:issued_check_processing_log.label.date')}
      </Typography>
      <Flex gap={12} align='center'>
        <CustomRangePicker
          style={{ width: 496 }}
          containerStyle={{ flex: 0, marginRight: 12 }}
          className='range-picker'
          value={dateRange}
          onChange={(values) => {
            setDateRange([dayjs(values?.[0], dateFormat), dayjs(values?.[1], dateFormat)])
          }}
          allowClear={false}
          disabledDate={disableFutureDates}
        />
        <Button icon={<RefreshIcon />} size={'large'} onClick={handleReset} />
        <Button
          icon={<WhiteSearchIcon />}
          type={'primary'}
          size={'large'}
          disabled={!dateRange?.length}
          onClick={handleSearch}
        />
      </Flex>
    </Flex>
  )
}

export default SearchBar
